<template>
  <div class="image-wrap">
    <img :src="img" />
  </div>
</template>

<script>

export default {
  name: 'SlideNewsImage',
  props: [
    'img'
  ],
  methods: {
    
  },
  mounted(){
    
  }
}
</script>

<style lang="scss" scoped>
  .image-wrap{
    position: relative;
    width: 265px;
    height: 265px;
    img{
      display: block;
      width: 100%;
    }
    @media screen and( max-width: 900px) {
      width: 100%;
      height: 140px;
      overflow: hidden;
      img{
        position: relative;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
</style>


// WEBPACK FOOTER //
// SlideNewsImage.vue?76b4d60e